"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Calendar = ({
  dayOfWeek,
  day,
  monthYear
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "w-28 py-4 bg-green-700 border border-green-800 rounded-lg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "text-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "font-medium text-white/90",
        children: dayOfWeek
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "text-4xl font-bold text-white",
        children: day
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "text-sm text-white/80",
        children: monthYear
      })]
    })
  });
};
var _default = exports.default = Calendar;